export type UnitTrackingProps = {};

export type UnitTrackingViewProps = {};

export type UnitTrackingTab = 'item' | 'case' | 'packg' | 'equipment';

export const isUnitTrackingTab = (value: string): value is UnitTrackingTab =>
  ['item', 'case', 'packg', 'equipment'].includes(value);

/**
 * Mixed into the tables rendered by the Unit Tracking page.
 *
 * `compType` is not decoration: useUrlSharing replaces the whole query
 * string with the keys its caller hands it, so the only way the active tab
 * survives a reload is for the mounted table to carry it in its own
 * urlRecord. Same approach as the History page's children.
 *
 * `embedded` suppresses the table's own page heading and UserPill so the
 * Unit Tracking page can own one of each. It defaults to undefined, which
 * keeps the standalone routes rendering exactly as they do today.
 */
export type UnitTrackingChildProps = {
  compType?: string;
  embedded?: boolean;
};
